export default function query(i) {
  return document.querySelector(i);
}
